import { makeStyles } from '@mui/styles';

import Colors from 'configs/Colors';

const useStyles = makeStyles(() => ({
  dialogPaper: {
    backgroundColor: Colors.Black,
    margin: 0,
    maxWidth: '100%',
    maxHeight: '100%',
  },
  container: {
    display: 'flex',
    height: '100vh',
    width: '100vw',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute !important',
    top: 16,
    right: 16,
    color: `${Colors.White} !important`,
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.4) !important',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.6) !important',
    },
  },
  zoomControls: {
    position: 'absolute',
    top: 16,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    borderRadius: 8,
    padding: '4px 12px',
    zIndex: 1000,
  },
  zoomButton: {
    color: `${Colors.White} !important`,
    padding: '8px !important',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1) !important',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.3) !important',
    },
  },
  zoomIndicator: {
    color: Colors.White,
    fontSize: 14,
    fontWeight: 500,
    minWidth: 50,
    textAlign: 'center',
  },
  sidebar: {
    width: 120,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    overflowY: 'auto',
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    msOverflowStyle: 'none',
  },
  thumbnailItem: {
    cursor: 'pointer',
    borderRadius: 4,
    overflow: 'hidden',
    border: '2px solid transparent',
    transition: 'all 0.2s ease',
    '&:hover': {
      opacity: 0.8,
      borderColor: 'rgba(255, 255, 255, 0.5)',
    },
  },
  thumbnailItemActive: {
    borderColor: `${Colors.White} !important`,
  },
  thumbnailImage: {
    width: '100%',
    height: 80,
    objectFit: 'cover',
  },
  centerArea: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: 40,
    background: Colors.Black,
    overflow: 'hidden',
    userSelect: 'none',
  },
  imageWrapper: {
    transition: 'transform 0.1s ease-out',
    transformOrigin: 'center center',
  },
  mainImage: {
    maxWidth: '100%',
    maxHeight: 'calc(100vh - 80px)',
    objectFit: 'contain',
    pointerEvents: 'none',
  },
  navigationButton: {
    position: 'absolute !important',
    color: `${Colors.White} !important`,
    backgroundColor: 'rgba(0, 0, 0, 0.4) !important',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.6) !important',
    },
  },
  prevButton: {
    left: 16,
  },
  nextButton: {
    right: 16,
  },
  imageCounter: {
    position: 'absolute',
    bottom: 16,
    left: '50%',
    transform: 'translateX(-50%)',
    color: Colors.White,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: '8px 16px',
    borderRadius: 20,
    fontSize: 14,
    fontWeight: 500,
  },
}));

export default useStyles;
